import React, { useEffect } from "react";
import Comments from "../reuseable/Comments";
import BlogContent from "../../utils/blogContent";
import RecentBlog from "../reuseable/RecentBlog";
import Author from "../reuseable/Author";
import BlogButtons from "../reuseable/BlogButtons";
import one from "../../images/blog/blog10/one.png";

const BlogTenHead = "FOOD AFFECTS NEURODIVERGENCE!!";
const BlogTen = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <>
        <div className="bgBlog10">
          <div className="lg:h-screen h-fit bg-black-bg">
            <div className="h-screen flex items-center justify-center p-4">
              <Author />

              <h1 className="text-4xl md:text-6xl text-white font-bold text-center">
                FOOD AFFECTS NEURODIVERGENCE!!
              </h1>
            </div>
          </div>
        </div>
      </>
      <>
        <div className="lg:ml-[10%] mx-[1%] flex flex-row-reverse">
          <RecentBlog BlogContent={BlogContent} />
          <div className="blog2 md:w-[80%] padding10px">
            <section>
              <h1>
                WHAT ARE YOUR FIRST THOUGHTS WHEN HEARING THE WORDS
                NEURODIVERSITY AND FOOD?
              </h1>
              <p>
                The connection between them is not one that can be easily made
                but it should be one that needs to be acknowledged by parents
                and adults. We must understand that for children with
                Neurodiversity children, numerous eating difficulties can exist.
                It is of utmost importance that children with Neurodiversity
                develop healthy eating habits. It is the responsibility of
                parents and caregivers to pay attention to dietary
                sensitivities, food aversions, allergies, and intolerances.
              </p>
              <p>
                Food sensitivities manifest when the body's immune system
                responds adversely to specific foods. This results in a variety
                of physical and cognitive symptoms. Certain textures or tastes
                of food may be overwhelming. In specific to ADHD, food
                sensitivities have the potential to aggravate inattention,
                impulsivity, and hyperactivity. It is necessary to identify and
                address potential trigger foods. An elimination diet is a method
                for removing potential trigger foods and gradually incorporating
                them again. This is a suggestion for parents suspecting food
                sensitivities in their children. Credits to @miroleyley.
              </p>
            </section>
            <section>
              <h1>Food Allergy</h1>
              <p>
                Food allergies occur when the immune system identifies certain
                proteins in food as harmful and reacts with various physical
                symptoms. It is important to note that not all children with
                Neurodiversity will experience food allergies and not all food
                allergies will have the same effects on children. Allergic
                reactions can cause not only behavioral or cognitive changes but
                can also create more communication difficulties, sensory
                sensitivities, and stress. Not all children can openly tell
                their parents, situations like this pay attention to kids being
                avoidant, reacting badly, or having meltdowns for certain foods.
                They may also be more irritable, and hyperactive. Trouble
                sleeping, or difficulty focusing.
              </p>
              <p>
                Children with Neuro-developmental disorders may be more prone to
                gluten and casein (A protein found in milk) intolerances. They
                may have difficulty digesting these proteins leading to
                gastrointestinal issues. Another common activity done not only
                by children but also by adults with Neurodiversity is having
                safe foods. These are foods people can trust to rely on or
                tolerate safely without side effects. An idea would be to have a
                personalised healthy diet for children with Neurodiversity. It
                is important to focus on providing a well-balanced and
                nutritious diet.
              </p>
            </section>
            <section>
              <h1>GUIDELINES</h1>
              <img src={one} alt="GUIDELINES" />
              <p className="pt-5">HERE ARE SOME GENERAL DIETARY GUIDELINES:</p>
              <li>
                <span>Whole foods</span>These are crucial for providing needed
                nutrients and supporting overall health. Such as fruits,
                vegetables, whole grains, lean proteins, and healthy fats.
              </li>
              <li>
                <span>Minimize processed foods</span>Reduce the intake of sugary
                and processed foods, they affect behavior and mood while causing
                more inflammation.
              </li>
              <li>
                <span>Limit Artificial Additives</span>Foods containing
                artificial colors, flavors, and preservatives.
              </li>
              <li>
                <span>Balanced Macronutrients</span>Including the right amount
                of carbohydrates, proteins, and fats.
              </li>
              <li>
                <span>Gluten-Free and Casein-Free Options</span>This is
                specifically for children with these intolerants. Alternatives
                can include using rice milk or almond milk instead of cow's milk
                and choosing gluten-free grains like rice, quinoa, or oats.
              </li>
              <li>
                <span>Zinc</span>shellfish, beans, peas, cashews, pork, lentils,
                and almonds daily. The nutrient Zinc affects the taste. This can
                be a game-changer for picky eaters.
              </li>
              <li>
                <span>Hydration</span>Make sure your child is drinking enough
                water throughout the day.
              </li>
              <li>
                <span>Individualized Approach</span>Do not forget, each child is
                unique and their dietary needs will vary.
              </li>
              <li>
                <span>Omega 3 Fatty acids</span>Fatty fish (mackerel, salmon,
                and sardines), walnuts, flaxseeds, and chia seeds. These help
                fight inflammation in the body and are essential for brain
                health and cognitive function.
              </li>
              <p>
                Finally, the best choice of action will always be consulting
                with a healthcare. professional, such as a pediatrician or
                registered dietitian, who is familiar with neurodivergent
                conditions to create a personalized diet plan.
              </p>
            </section>
            <section>
              <div className="flex flex-col text-left">
                <li>
                  <a href="https://benedlife.com/blogs/news/neurodivergent-eating-developing-a-healthy-relationship-with- food#:-:text=Sensory%20Sensitivity%20and%20Food%20Aversion, the%20two%20conditions%20ca n%20be">
                    Sensitivity
                  </a>
                </li>
                <li>
                  <a href="https://advancingmilestones.com/wp-content/uploads/2020/02/Difference-Between-Allergy-Sens- Intol.pdf">
                    Difference between intolerance, sensitivity, allergy
                  </a>
                </li>
                <li>
                  <a href="https://elemy.wpengine.com/studio/autism-and-diet/food-allergies">
                    Autism allergy
                  </a>
                </li>
                <li>
                  <a href="https://www.psychologytoday.com/us/blog/eating-disorders-among-gender-expansive-and- neurodivergent-individuals/202210/the- correlation #:-:text=Neurodivergent%20individuals%20may%20experience%20symptoms,connecting %20with%20bodily%20hunger%20cues">
                    A little bit about sensory sensitivity
                  </a>
                </li>
                <li>
                  <a href="https://www.autismspeaks.org/expert-opinion/what-it-about-autism-and-food- O#:-:text=Research%20also%20tells%20us%20that, to%20strong%20tastes%20and%20textures">
                    Autism and food
                  </a>
                </li>
                <li>
                  <a href="https://icandreamcenter.com/nutrition-diet-for-autism-supporting-kids-on-the-spectrum- naturally/#:-:text=The%20best%20food%20for%20children.beans%2C%20nuts%2C%20and%20see ds.&text=Research%20has%20found%20that%20fatty fight%20inflammation%20in%20the%20body">
                    Autism diet
                  </a>
                </li>
                <li>
                  <a href="https://www.additudemag.com/adhd-diet-nutrition-sugar/">
                    Adhd diet
                  </a>
                </li>
                <li>
                  <a href="https://www.autismspeaks.org/expert-opinion/autism-and-food- aversions#:-:text=Autism%20often%20comes%20with%20hypersensitivity, smooth%20out%20the% 20offending%20texture">
                    Autism food aversions
                  </a>
                </li>

                <li>
                  <a href="https://www.ldrfa.org/simple-diet-changes-will-improve-add-symptoms/">
                    diet
                  </a>
                </li>
                <li>
                  <a href="https://www.wiseheartnutrition.com/blog/food-variety-and-eating-with-a-neurodivergent- brain#:-:text=Neurodivergent%20folx%20will%20become%20fixated, feel%20uninteresting%2C%20 or%20even%20disgusting">
                    Importance of variety
                  </a>
                </li>
                <li>
                  <a href="https://www.additudemag.com/testing-for-food-sensitivities-in-children-with-adhd/">
                    Adhd & food sensitivities
                  </a>
                </li>
              </div>
              <BlogButtons BlogContent={BlogContent} />
            </section>
          </div>
        </div>
      </>
      <Comments blog={BlogTenHead} />
    </>
  );
};

export default BlogTen;
